const baseTheme = {
  fonts: {
    mono: '"SF Mono", "Roboto Mono", Menlo, monospace',
  },
};

const lightTheme = {
  ...baseTheme,
  colors: {
    background: '#fff',
    heading: '#000',
    text: '#141c22',
    preFormattedText: 'rgb(245, 247, 249)',
    link: '#1000EE',
    fontWeight: '400',
    lineHeight: '1.25',
  },

  bgColors: {
    backgroundColor: '#0000000d;',
  },

  bgActive: {
    backgroundColor: '#fceeeb',
    color: '#141c22',
  },
};

const darkTheme = {
  ...baseTheme,
  colors: {
    background: 'rgb(20, 20, 20)',
    heading: '#fff',
    text: 'rgba(255, 255, 255, 0.65)',
    preFormattedText: '#000',
    link: '#1ED3C6',
  },

  bgColors: {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
  },

  bgActive: {
    backgroundColor: '#FFF',
    color: '#fff',
  },
};

export { lightTheme, darkTheme };
